import {checkMethod} from '../../utils/validate';
import {pApiKey, debug} from '../../config';

/* eslint-disable require-jsdoc */ function getAjaxOpts(url, method, auth) {
  const opts = {};
  opts.url = url;
  const httpMethod = checkMethod(method);
  if (httpMethod == 'method issue') {
    return httpMethod;
  }
  opts.method = httpMethod;
  if (auth) {
    opts.headers = {
      Authorization: 'Bearer ' + pApiKey,
    };
  }
  debug && console.log('ajax opts ', opts);
  return opts;
}
export {getAjaxOpts};
